import { z } from 'zod';
import { ColorSchema, IsoDateSchema } from './common';
import { RoleSchema } from './role';

export const UserCodeSchema = z
  .string()
  .min(2)
  .max(3)
  .regex(/^[A-Z]+$/, 'Code must be 2-3 uppercase letters');

export const CreateUserSchema = z.object({
  code: UserCodeSchema,
  name: z.string().min(1),
  email: z.string().email(),
  password: z.string().min(8),
  color: ColorSchema.default('A'),
  roleId: z.string().uuid(),
  managerId: z.string().uuid().nullable().optional(),
  joinedAt: IsoDateSchema,
});
export type CreateUserRequest = z.infer<typeof CreateUserSchema>;

export const UpdateUserSchema = z.object({
  name: z.string().min(1).optional(),
  email: z.string().email().optional(),
  color: ColorSchema.optional(),
  roleId: z.string().uuid().optional(),
  managerId: z.string().uuid().nullable().optional(),
  active: z.boolean().optional(),
});
export type UpdateUserRequest = z.infer<typeof UpdateUserSchema>;

export const PublicUserSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  email: z.string(),
  color: ColorSchema,
  role: RoleSchema,
  isSystemAdmin: z.boolean(),
  managerId: z.string().uuid().nullable(),
  active: z.boolean(),
  joinedAt: z.string(),
});
export type PublicUser = z.infer<typeof PublicUserSchema>;
